import { demoTag } from "@Containers/game/challenges/utils";
import useDemoAccount from "@hooks/common/user/use-demo-account";
import useI18n from "@i18n";
import HeroBannerCard from "./hero-banner-card";

const HeroBannerFallback = () => {
  const { i18n } = useI18n();
  const { isDemo } = useDemoAccount();

  return !isDemo ? (
    <HeroBannerCard
      challenge={{
        id: null,
        title: i18n("career.label"),
        goal: i18n("challenges.fallback.career.caption"),
        image_url: "",
      }}
      challengeText={i18n("be-your-best")}
      navText={i18n("continue")}
      navTo="/home/career"
    />
  ) : (
    <HeroBannerCard
      challenge={{
        id: null,
        title: i18n("challenges.fallback.demo.title"),
        goal: i18n("challenges.fallback.demo.caption"),
        image_url: "",
      }}
      challengeText={i18n("be-your-best")}
      navText={i18n("explore")}
      navTo={`/challenges/category/${demoTag.id}`}
    />
  );
};

export default HeroBannerFallback;
